import {
  GET_PO_LISTING_REQUEST,
  GET_PO_LISTING_SUCCESS,
  GET_PO_LISTING_FAILURE,
  GET_PO_PROCESS_LOG_REQUEST,
  GET_PO_PROCESS_LOG_SUCCESS,
  GET_PO_PROCESS_LOG_FAILURE,
  GET_ROUTING_INFO_BY_PO_REQUEST,
  GET_ROUTING_INFO_BY_PO_SUCCESS,
  GET_ROUTING_INFO_BY_PO_FAILURE,
  GET_OPERATIONS_LIST_BY_PO_REQUEST,
  GET_OPERATIONS_LIST_BY_PO_SUCCESS,
  GET_OPERATIONS_LIST_BY_PO_FAILURE,
  GET_PO_PROCESS_LOG_REPORTS_SUCCESS,
  GET_PO_PROCESS_LOG_REPORTS_REQUEST,
  GET_PO_PROCESS_LOG_REPORTS_FAILURE,
  GET_PO_LISTING_WITHOUT_PAGINATION_REQUEST,
  GET_PO_LISTING_WITHOUT_PAGINATION_FAILURE,
  GET_PO_LISTING_WITHOUT_PAGINATION_SUCCESS,
  GET_COMPLETED_PO_LISTING_REQUEST,
  GET_COMPLETED_PO_LISTING_SUCCESS,
  GET_COMPLETED_PO_LISTING_FAILURE,
  GET_CONSUMED_SUIDS_REQUEST,
  GET_CONSUMED_SUIDS_SUCCESS,
  GET_CONSUMED_SUIDS_FAILURE,
} from "./poManagementTypes";

const initialState = {
  loading: false,
  poListing: [],
  error: "",
};

const getPoListingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PO_LISTING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PO_LISTING_SUCCESS:
      return {
        loading: false,
        poListing: action.payload,
        error: "",
      };
    case GET_PO_LISTING_FAILURE:
      return {
        loading: false,
        poListing: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForPoProcessLog = {
  loading: false,
  poProcessLog: [],
  error: "",
};

const getPoProcessLogReducer = (
  state = initialStateForPoProcessLog,
  action
) => {
  switch (action.type) {
    case GET_PO_PROCESS_LOG_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PO_PROCESS_LOG_SUCCESS:
      return {
        loading: false,
        poProcessLog: action.payload,
        error: "",
      };
    case GET_PO_PROCESS_LOG_FAILURE:
      return {
        loading: false,
        poProcessLog: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForRoutingInfoByPO = {
  loading: false,
  routingInfoByPO: [],
  error: "",
};

const getRoutingInfoByPOReducer = (
  state = initialStateForRoutingInfoByPO,
  action
) => {
  switch (action.type) {
    case GET_ROUTING_INFO_BY_PO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ROUTING_INFO_BY_PO_SUCCESS:
      return {
        loading: false,
        routingInfoByPO: action.payload,
        error: "",
      };
    case GET_ROUTING_INFO_BY_PO_FAILURE:
      return {
        loading: false,
        routingInfoByPO: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForOperationsListByPO = {
  loading: false,
  operationsListByPO: [],
  error: "",
};

const getOperationsListByPOReducer = (
  state = initialStateForOperationsListByPO,
  action
) => {
  switch (action.type) {
    case GET_OPERATIONS_LIST_BY_PO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_OPERATIONS_LIST_BY_PO_SUCCESS:
      return {
        loading: false,
        operationsListByPO: action.payload,
        error: "",
      };
    case GET_OPERATIONS_LIST_BY_PO_FAILURE:
      return {
        loading: false,
        operationsListByPO: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForPoProcessLogReports = {
  loading: false,
  poProcessLogReports: [],
  error: "",
};

const getPoProcessLogReportsReducer = (
  state = initialStateForPoProcessLogReports,
  action
) => {
  switch (action.type) {
    case GET_PO_PROCESS_LOG_REPORTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PO_PROCESS_LOG_REPORTS_SUCCESS:
      return {
        loading: false,
        poProcessLogReports: action.payload,
        error: "",
      };
    case GET_PO_PROCESS_LOG_REPORTS_FAILURE:
      return {
        loading: false,
        poProcessLogReports: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateWithoutPagination = {
  loading: false,
  poListing: [],
  error: "",
};

const getPoListingWithoutPaginationReducer = (
  state = initialStateWithoutPagination,
  action
) => {
  switch (action.type) {
    case GET_PO_LISTING_WITHOUT_PAGINATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PO_LISTING_WITHOUT_PAGINATION_SUCCESS:
      return {
        loading: false,
        poListing: action.payload,
        error: "",
      };
    case GET_PO_LISTING_WITHOUT_PAGINATION_FAILURE:
      return {
        loading: false,
        poListing: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForCompltedPo = {
  loading: false,
  poListing: [],
  error: "",
};

const getCompletedPoListingReducer = (
  state = initialStateForCompltedPo,
  action
) => {
  switch (action.type) {
    case GET_COMPLETED_PO_LISTING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPLETED_PO_LISTING_SUCCESS:
      return {
        loading: false,
        poListing: action.payload,
        error: "",
      };
    case GET_COMPLETED_PO_LISTING_FAILURE:
      return {
        loading: false,
        poListing: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForConsumedSuids = {
  loading: false,
  consumedSuids: [],
  error: "",
};

const getConsumedSuidsReducer = (
  state = initialStateForConsumedSuids,
  action
) => {
  switch (action.type) {
    case GET_CONSUMED_SUIDS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_CONSUMED_SUIDS_SUCCESS:
      return {
        loading: false,
        consumedSuids: action.payload,
        error: "",
      };
    case GET_CONSUMED_SUIDS_FAILURE:
      return {
        loading: false,
        consumedSuids: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export {
  getPoListingReducer,
  getPoProcessLogReducer,
  getRoutingInfoByPOReducer,
  getPoProcessLogReportsReducer,
  getOperationsListByPOReducer,
  getPoListingWithoutPaginationReducer,
  getCompletedPoListingReducer,
  getConsumedSuidsReducer,
};
